import React from 'react';
import { CHEVRON_DOWN__16, CHEVRON_UP__16 } from '@homeaway/svg-defs';
import { SVGIcon } from '@homeaway/react-svg';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { renderPropValue } from '../../utils/renderPropEventValues';
import "./EventDocsRow.css";

function formatSpecLink(eventName) {
  if (eventName === void 0) {
    eventName = '';
  }

  // TODO: Eventually this url should be driven through configuration.
  return "//github.homeawaycorp.com/pages/edap/adl-json-schema/specs/latest/events/" + eventName.replace(/\./g, '-');
} // eslint-disable-next-line complexity


function EventDocsRow(_ref) {
  var expander = _ref.expander,
      fields = _ref.fields,
      isExpanded = _ref.isExpanded,
      method = _ref.method,
      name = _ref.name,
      onExpand = _ref.onExpand,
      options = _ref.options,
      parentNode = _ref.parentNode;
  var rowClass = classnames('EventDocsRow__tr', {
    'EventDocsRow__tr-expanded': !expander && isExpanded
  });
  return /*#__PURE__*/React.createElement("tr", {
    className: rowClass
  }, /*#__PURE__*/React.createElement("td", {
    className: "EventDocsRow__td EventDocsRow__td--monospace EventDocsRow__td--name"
  }, (!isExpanded || expander) && /*#__PURE__*/React.createElement("a", {
    className: "EventDocs__td--name",
    href: formatSpecLink(name),
    target: "_blank"
  }, name)), !expander && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
    className: "EventDocsRow__td EventDocsRow__td--monospace EventDocsRow__td--fields"
  }, fields ? renderPropValue(fields, true, parentNode) : '{}'), /*#__PURE__*/React.createElement("td", {
    className: "EventDocsRow__td EventDocsRow__td--monospace EventDocsRow__td--options"
  }, options ? renderPropValue(options, true, parentNode) : '{}'), /*#__PURE__*/React.createElement("td", {
    className: "EventDocsRow__td EventDocsRow__td--monospace EventDocsRow__td--type"
  }, method)), expander && /*#__PURE__*/React.createElement("td", {
    colSpan: "3",
    className: "EventDocsRow__td"
  }, /*#__PURE__*/React.createElement("button", {
    title: isExpanded ? 'Hide Methods' : 'Show Methods',
    className: "EventDocsRow__expander",
    onClick: onExpand,
    "data-event-name": name,
    "aria-expanded": isExpanded
  }, /*#__PURE__*/React.createElement("div", {
    className: "EventDocsRow__expander-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EventDocsRow__expander-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EventDocsRow__expander-line"
  })), /*#__PURE__*/React.createElement("div", {
    className: "EventDocsRow__expander-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EventDocsRow__expander-label"
  }, expander), /*#__PURE__*/React.createElement(SVGIcon, {
    markup: isExpanded ? CHEVRON_UP__16 : CHEVRON_DOWN__16
  }))))));
}

EventDocsRow.propTypes = {
  expander: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.object),
  isExpanded: PropTypes.bool,
  method: PropTypes.string,
  name: PropTypes.string,
  onExpand: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  parentNode: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
};
EventDocsRow.defaultProps = {
  isExpanded: false,
  onExpand:
  /* istanbul ignore next */
  function onExpand() {}
};
export default React.memo(EventDocsRow);
//# sourceMappingURL=EventDocsRow.js.map